<template>
  <Layout>
      <template #content>
        <div class="join_alone pc_agent">
          <pageHead device="desktop" page="agent_signup" :title="$t('store.btn.agent_sign')" />

          <div class="join_alone-con">
            <div class="join_alone_bg">
              
              <!-- 加入會員 -->
              <div class="modal-main joinus">
                <div class="title">{{ $t("store.user.join_agent") }}</div>
                <b-form @submit.stop.prevent="onSubmit">

                  <template v-if="$v.form.$model.upagent">
                    <b-form-group :label="$t('store.user.agent')">
                      <b-form-input :value="$v.form.$model.upagent" readonly />
                    </b-form-group>
                  </template>

                  <template v-for="item in AgentSign">
                    <b-form-group
                      :key="item.id"
                      :label="$t(`store.user.${item.field}`)"
                      :label-for="`input-${item.field}`"
                    >
                      <template v-if="item.field == 'account'">
                        <b-form-input
                          class="pdright"
                          :id="`input-${item.field}`"
                          :name="item.field"
                          :state="validateState(item.field)"
                          v-model="$v.form[item.field].$model"
                        />
                      </template>

                      <template v-else-if="item.field == 'birthday'">
                        <b-form-input
                          :id="`input-${item.field}`"
                          type="date"
                          :name="item.field"
                          v-model="$v.form[item.field].$model"
                          :state="validateState(item.field)"
                        />
                      </template>

                      <template v-else-if="item.type == 'password'">
                        <b-form-input
                          :id="`input-${item.field}`"
                          :type="item.type"
                          :name="item.field"
                          v-model="$v.form[item.field].$model"
                          :state="validateState(item.field)"
                        />
                        <div class="pw-toggle" @click="changeIcon(item.field)"><i :class="pwIconData[item.field] || 'icon icon-eye'"></i></div>
                      </template>

                      <template v-else-if="item.field == 'w_code'">
                        <b-form-select
                          v-for="i in 4"
                          :key="i"
                          class="pin"
                          v-model="WCode[`${item.field}_${i}`]"
                        >
                          <Option v-for="n in 10" :key="n - 1" :value="n - 1">{{
                            n - 1
                          }}</Option>
                        </b-form-select>
                      </template>

                      <template v-else>
                        <b-form-input
                          :id="`input-${item.field}`"
                          :name="item.field"
                          v-model="$v.form[item.field].$model"
                          :state="validateState(item.field)"
                        />
                      </template>

                      <b-form-invalid-feedback>{{ $t(`store.user.${item.field}`) }}{{ $t("store.tip_cant_required") }}</b-form-invalid-feedback>
                      <b-form-text id="input-live-help" v-if="item.notice">
                        <i class="icon icon-infomation"></i>{{ $t(`store.user.${item.field}_notice`, { max: AccountLen }) }}
                      </b-form-text>
                    </b-form-group>

                    <!-- <template v-if="item.field == 'mobile' && ShowAgentSignMobileCaptchas">
                      <b-form-group :label="$t('store.btn.CAPTCHA')" label-for="input-usercaptcha">
                        <b-form-input
                          id="input-usercaptcha"
                          name="usercaptcha"
                          v-model="$v.form.usercaptcha.$model"
                          :state="validateState('usercaptcha')"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-9-feedback">{{ $t("store.tip_cant_captcha_required") }}</b-form-invalid-feedback>
                      </b-form-group>
                    </template> -->

                  </template>

                  <template v-if="ShowAgentSignCaptchas">
                    <b-form-group :label="$t('store.btn.CAPTCHA')" label-for="input-usercaptcha">
                      <b-form-input
                        id="input-signcaptcha"
                        name="signcaptcha"
                        v-model="$v.form.signcaptcha.$model"
                        :state="validateState('signcaptcha')"
                      />
                      <b-form-invalid-feedback id="input-9-feedback">{{ $t("store.tip_cant_captcha_required") }}</b-form-invalid-feedback>
                      <img :src="SignCaptchasImg" @click="_changeSignCaptchas" class="signcaptcha_img" />
                    </b-form-group>
                  </template>
                  
                  <hr />

                  <b-form-checkbox id="form-agreement" name="form-agreement" v-model="form.accepted">
                    {{ $t("store.get_agree") }}<b-link @click="ruleModal" ref="btnRule">{{ $t("store.terms") }}</b-link>
                  </b-form-checkbox>

                  <dialogRule />

                  <b-button type="submit" variant="submit">{{ $t("store.btn.submit_confirm") }}</b-button>

                </b-form>
              </div>

            </div>
          </div>
        </div>
      </template>
  </Layout>
</template>
<script>
  const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  import pageHead from "~/components/common/pageHead.vue";
  import dialogRule from "~/components/desktop/dialogRule.vue";
  export default {
    name: "agent_signup",
    // middleware: ["checkNoLogin"],
    mixins: [validationMixin],
    components: {
      Layout,
      pageHead,
      dialogRule,
    },
    data() {
      return {
        title: this.$t("store.btn.agent_sign"),
        pwIconData: {
          'password': "icon icon-eye",
          'password_confirmation': "icon icon-eye"
        },
        isSubmit: false,
        form: {
          account: null,
          password: null,
          password_confirmation: null,
          name: null,
          nickname: null,
          mobile: null,
          email: null,
          w_code: null,
          birthday: null,
          line_id: null,
          whats_app: null,
          usercaptcha: null,
          signcaptcha: null,
          upagent: null,
          accepted: false,
        },
        WCode: {
          w_code_1: 0,
          w_code_2: 0,
          w_code_3: 0,
          w_code_4: 0,
        },
        ButCheckAccount: { disabled: false, check: false },
        ButSendMobileCode: this.handleButSendMobileCode(),
      };
    },
    validations() {
      let form = {
        account: {},
        password: {},
        password_confirmation: {},
        name: {},
        nickname: {},
        mobile: {},
        email: {},
        w_code: {},
        birthday: {},
        line_id: {},
        whats_app: {},
        usercaptcha: {},
        signcaptcha: {},
        upagent: {},
        agree: {},
      };

      if (this.AgentSign) {
        for (var item in this.AgentSign) {
          if (Object.keys(form).indexOf(item) < 0)
            form[this.AgentSign[item].field] = {};
        }
      }
      
      if (this.AgentSignValidations) {
        for (var item in this.AgentSignValidations) {
          if (Object.keys(form).indexOf(item) >= 0)
            form[item] = this.AgentSignValidations[item];
        }
      }

      return { form };
    },
    methods: {
      changeIcon(field){
        const pw = document.getElementById(`input-${field}`);
        if(pw.type === 'password'){
          pw.setAttribute('type','text');
          this.pwIconData[field] = 'icon icon-noeye';
        }else{
          pw.setAttribute('type','password');
          this.pwIconData[field] = 'icon icon-eye';
        }
      },
      validateState(name) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      },
      resetForm() {
        for (var item in this.form) {
          this.form[item] = "";
        }

        this.$nextTick(() => {
          this.$v.$reset();
        });
      },
      onSubmit() {
        this.$v.form.$touch();
        if (this.$v.form.$anyError)
          return;

        const { account, password, accepted } = this.$v.form.$model;
        if (account == password) {
          this._showMsgBox({ title: this.$t("store.tip"), msg: this.$t("store.pw.tip_idpw_not_same") });
          return;
        }

        if (!accepted) {
          this._showMsgBox({ title: this.$t("store.tip"), msg: this.$t("store.tip_plz_agree") });
          return;
        }

        if (this.isSubmit)
          return;

        // if (this.UpAgentCode)
        //   this.$v.form.$model.upagent = this.UpAgentCode;

        this.isSubmit = true;
        this.AgentInsert(this.$v.form.$model).then((res) => {
          this._changeSignCaptchas();
          this.isSubmit = false;
          if (res)
            this.resetForm();
        });
      },
      ruleModal() {
        this.$root.$emit("bv::toggle::modal", "modalRule", "#ModalRuleRef");
      },
      setWCode() {
        let WCode = "";
        WCode += this.WCode.w_code_1 ? this.WCode.w_code_1 : "0";
        WCode += this.WCode.w_code_2 ? this.WCode.w_code_2 : "0";
        WCode += this.WCode.w_code_3 ? this.WCode.w_code_3 : "0";
        WCode += this.WCode.w_code_4 ? this.WCode.w_code_4 : "0";
        this.$v.form["w_code"].$model = WCode;
      },
      handleButSendMobileCode() {
        return {
          disabled: false,
          check: false,
          seconds: 60 * 1,
          reciprocal: 0,
          text: this.$t("store.btn.verify_btn"),
          timer: null,
        };
      },
      handleInsideForm () {
        if (this.AgentSign) {
          for (var item in this.AgentSign) {
            if (Object.keys(this.form).indexOf(this.AgentSign[item].field) < 0)
              this.$set(this.form, this.AgentSign[item].field, null);
          }
        }
      },
      changeLang() {
        this.ButSendMobileCode = this.handleButSendMobileCode();
        this.title = this.$t("store.btn.agent_sign");
      },
      ...mapActions(["_showMsgBox", '_changeSignCaptchas']),
      ...mapActions("account", ["CheckAccount", "SendMobileCode"]),
      ...mapActions("agent", ["_getAgentSign", "AgentInsert"]),
      ...mapMutations(["_setUpAgentCode"]),
    },
    mounted() {
      this._getAgentSign().then((res) => { this.handleInsideForm(); });
      this._changeSignCaptchas();
      this.setWCode();
      this.changeLang();
    },
    watch: {
      "$v.form.account.$model"(value) {
        if (this.ButCheckAccount.check) this.ButCheckAccount.check = false;
      },
      "$v.form.area_code.$model"(value) {
        if (this.ButSendMobileCode.check) this.ButSendMobileCode.check = false;
      },
      "$v.form.mobile.$model"(value) {
        if (this.ButSendMobileCode.check) this.ButSendMobileCode.check = false;
      },
      "WCode.w_code_1"() {
        this.setWCode();
      },
      "WCode.w_code_2"() {
        this.setWCode();
      },
      "WCode.w_code_3"() {
        this.setWCode();
      },
      "WCode.w_code_4"() {
        this.setWCode();
      },
      "$i18n.locale"(language) {
        this.changeLang();
      }
    },
    computed: {
      AgentSignMobile() {
        return this.$store.getters["account/AgentSignInfo"]("mobile");
      },
      AccountLen() {
        return parseInt(Object.keys(this.WebSetting).indexOf('ACCOUNT_LEN') >= 0 ? this.WebSetting.ACCOUNT_LEN : 10);
      },
      ...mapState(["WebSetting", 'SignCaptchasImg', 'UpAgentCode']),
      ...mapGetters("agent", ["AgentSign", "AgentSignValidations"]),
      ...mapGetters('webSetting', ['ShowAgentSignCaptchas', 'ShowAgentSignMobileCaptchas'])
    }

  };
</script>
